import getApiInstance from 'data/common/ApiCallGenerique';
/** @var Logger Logger */
import Logger from 'data/common/Logger';
import api from './api';
/** @var ApiCall apiCaller */
const apiCaller = getApiInstance();

export function getManagements(env) {
    return dispatch => {
        return apiCaller
            .call(api.getAllManagements(env))
            .then(({ data }) => {
                if (data.success) {
                    console.log(data, 'lalalala')
                    if (data.managements) {
                        dispatch({
                            type: `${env.toUpperCase()}__SET_MANAGEMENTS`,
                            managements: data.managements,
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setManagements - ', error);
                throw error;
            });
    };
}

export function getManagementDetails(env, managementId) {
    return dispatch => {
        return apiCaller
            .call(api.getManagementDetails(env, managementId))
            .then(({ data }) => {
                if (data.success) {
                    if (data.managementHomes) {
                        dispatch({
                            type: `${env.toUpperCase()}__UPDATE_HOMES`,
                            homes: data.managementHomes,
                        });
                    }
                    if (data.managementCraftsmen) {
                        dispatch({
                            type: `${env.toUpperCase()}__UPDATE_CRAFTSMEN`,
                            craftsmen: data.managementCraftsmen,
                        });
                    }
                    if (data.managementManagers) {
                        dispatch({
                            type: `${env.toUpperCase()}__UPDATE_USERSMANAGERS`,
                            usersManagers: data.managementManagers,
                        });
                    }
                    dispatch({
                        type: `${env.toUpperCase()}__SET_MANAGEMENT`,
                        managementId,
                        management: data.managementDetails,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setManagementDetails - ', error);
                throw error;
            });
    };
}

export function updateManagementDetails(env, managementId, managementForm) {
    return dispatch => {
        return apiCaller
            .call(api.updateManagementDetails(env, managementId, managementForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `${env.toUpperCase()}__UPDATE_MANAGEMENT`,
                        managementId,
                        management: data.management,
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setManagementDetails - ', error);
                throw error;
            });
    };
}

export function addManagement(env, managementForm) {
    return () => {
        return apiCaller
            .call(api.addManagement(env, managementForm))
            .then(({ data }) => {
                return data.managementId;
            })
            .catch(error => {
                Logger.log('dataActions: setAddManagement - ', error);
                throw error;
            });
    };
}



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Managements/actions.js